import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n/LocaleContext';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Center mih="100vh">
      <Stack align="center" gap="md">
        <Title order={1} size={64}>
          404
        </Title>
        <Text c="dimmed">{t('notFound.message')}</Text>
        <Button component={Link} to="/dashboard">
          {t('notFound.backToDashboard')}
        </Button>
      </Stack>
    </Center>
  );
}
